import { EventName } from '@lit/react';
import { BlocksTooltip } from 'blocks-nextjs/blocks-web-components/components/tooltip/tooltip';
import { BlocksCloseEvent, BlocksOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTooltip = createComponent({
  react: React,
  tagName: 'cat-tooltip',
  elementClass: BlocksTooltip,
  events: {
    onBlTooltipClose: 'bl-tooltip-close' as EventName<BlocksCloseEvent>,
    onBlTooltipOpen: 'bl-tooltip-open' as EventName<BlocksOpenEvent>
  }
});
